import { http } from "@/utils/http"
import {
  GET_DASHBOARD_STATISTICS_URL,
  GET_REVENUE_CHART_DATA_URL,
  GET_REVENUES_URL,
} from "@/constants/api/endpoints"

export const getDashboardStatistics = async () => {
  return http.get(GET_DASHBOARD_STATISTICS_URL)
}

export const getMonthlyRevenueData = async () => {
  return http.get(GET_REVENUE_CHART_DATA_URL)
}

export const getRevenues = async () => http.get(GET_REVENUES_URL)